export default "__VITE_ASSET__BVDK6LmQ__"